import React from 'react';
import { Link } from 'react-router-dom';
import { dollarFormat, getPropByString, toTitleCase } from 'utils/utils';
import { convertDateFromApiToUserTimezone } from 'utils/utility_functions/timezone';
import constants from 'constants/index';

export const caseNameBody = (params) => {
  const { rowData, hidden } = params || {};
  if (!rowData || hidden) {
    return (
      <React.Fragment>
        <span className="p-column-title text-break">Case Name</span>
        <span>-</span>
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      <span className="p-column-title text-break">Case Name</span>
      <span className="text-break">
        <Link
          className="cursor-pointer text-decoration-none F-size14 call-back"
          to={`/${rowData?.is_lead ? 'leads' : 'cases'}/${rowData?.case_id}`}
          title={getPropByString(rowData, 'case_name')}
        >
          {getPropByString(rowData, 'case_name')}
        </Link>
      </span>
    </React.Fragment>
  );
};

export const dateBody = (params) => {
  const { rowData, userContext } = params || {};
  if (!rowData) {
    return (
      <React.Fragment>
        <span className="p-column-title text-break">Date of Transaction</span>
        <span>-</span>
      </React.Fragment>
    );
  }
  const formattedDate = convertDateFromApiToUserTimezone(
    rowData?.record_created_date,
    userContext?.userDetails?.timezone,
    constants.month_date_year_format
  );
  return (
    <React.Fragment>
      <span className="p-column-title text-break">Date of Transaction</span>
      <span className="text-break" title={formattedDate !== '-' ? formattedDate : undefined}>
        {formattedDate}
      </span>
    </React.Fragment>
  );
};

export const paidFromBody = (params) => {
  const { rowData } = params || {};
  if (!rowData) {
    return (
      <React.Fragment>
        <span className="p-column-title text-break">Paid From</span>
        <span>-</span>
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      <span className="p-column-title text-break">Paid From</span>
      <span className="text-break">
        {rowData?.debit_account_name ? (
          <Link to="/settings/accounts" className="call-back text-decoration-none" title={rowData?.debit_account_name}>
            {rowData?.debit_account_name}
          </Link>
        ) : (
          '-'
        )}
      </span>
    </React.Fragment>
  );
};

export const paidToBody = (params) => {
  const { rowData } = params || {};
  if (!rowData) {
    return (
      <React.Fragment>
        <span className="p-column-title text-break">Paid To</span>
        <span>-</span>
      </React.Fragment>
    );
  }
  const { credit_account_name, provider, vendor, checked_contact, contact_id, contact_name, referral_contact, paid_to } = rowData || {};

  if (credit_account_name) {
    return (
      <React.Fragment>
        <span className="p-column-title text-break">Paid To</span>
        <span>
          <Link to="/settings/accounts" className="call-back text-decoration-none" title={paid_to ? paid_to : undefined}>
            {paid_to ? paid_to : '-'}
          </Link>
        </span>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <span className="p-column-title text-break">Paid To</span>
      <span>
        <Link
          to={`/contacts/${
            provider?.contact_id || vendor?.contact_id || checked_contact?.contact_id || contact_id || referral_contact?.contact_id
          }`}
          className="call-back text-decoration-none"
          title={paid_to ? paid_to : undefined}
        >
          {paid_to ? paid_to : '-'}
        </Link>
      </span>
    </React.Fragment>
  );
};

export const paymentTypeBody = (params) => {
  const { rowData } = params || {};
  if (!rowData) {
    return (
      <React.Fragment>
        <span className="p-column-title text-break">Payment Type</span>
        <span>-</span>
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      <span className="p-column-title text-break">Payment Type</span>
      <span title={toTitleCase(rowData?.payment_type)}>{toTitleCase(rowData?.payment_type)}</span>
    </React.Fragment>
  );
};

export const amountBody = (params) => {
  const { rowData } = params || {};
  if (!rowData) {
    return (
      <React.Fragment>
        <span className="p-column-title text-break">Amount</span>
        <span>-</span>
      </React.Fragment>
    );
  }
  const { entry_type } = rowData;
  return (
    <React.Fragment>
      <span className="p-column-title text-break">Amount</span>
      <span>
        <span className={entry_type === 'cr' ? 'text-success' : 'text-danger'} title={dollarFormat(rowData?.amount)}>
          {dollarFormat(rowData?.amount)}
        </span>
      </span>
    </React.Fragment>
  );
};

export const rowClassName = (rowData) => ({ strikethrough: rowData.is_strikethrough });
